// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"2ca05e76","722":"438bb51e"}[chunkId] + ".chunk.js";
};